export type LeadSourceKind = 'image' | 'audio' | 'other';

const SOURCE_EXT_MIME: Record<string, string> = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    webm: 'audio/webm',
    m4a: 'audio/mp4',
    mp4: 'audio/mp4',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    ogg: 'audio/ogg',
    aac: 'audio/mp4',
};

export function leadSourceKind(path: string): LeadSourceKind {
    if (/\.(png|jpe?g)$/i.test(path)) return 'image';
    if (/\.(webm|m4a|mp3|wav|ogg|aac|mp4)$/i.test(path)) return 'audio';
    return 'other';
}

/** Infer playback MIME from stored path when the response type is missing or generic. */
export function leadSourceMimeFromPath(path: string): string | null {
    const match = /\.([^.]+)$/i.exec(path);
    if (!match) return null;
    return SOURCE_EXT_MIME[match[1].toLowerCase()] ?? null;
}

export function leadSourceLabel(path: string): string {
    return path.split('/').pop() || 'Source';
}

export function effectiveLeadSources(
    sourcePaths?: string[] | null,
    sourcePath?: string | null
): string[] {
    if (sourcePaths?.length) return sourcePaths.filter(Boolean);
    if (sourcePath) return [sourcePath];
    return [];
}
